import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const LinkComponent = () => {
    const { id1, id2, id3, id4 } = useParams();
    const location = useLocation();

    const ids = [id1, id2, id3, id4];

    const formatId = (id) => {
        if (!id) return '';
        return id
            .split('-')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    const lastIdIndex = ids.map((id) => Boolean(id)).lastIndexOf(true);

    const fadeInUp = (delay = 0) => ({
        initial: {
            translateY: -10,
            opacity: 0,
        },
        animate: {
            translateY: 0,
            opacity: 1,
            transition: {
                duration: 1,
                delay: delay,
            },
        },
    });

    const firstSegment = location.pathname.split('/')[1]; // 'projeler' veya 'sistemler' gibi

    const firstSegmentLabel = formatId(firstSegment); // Baş harf büyük hale getirmek için

    return (
        <div className="w-full grid grid-cols-14 pb-8 bg-white">
            <div className="col-start-2 col-span-12 flex text-16 flex-wrap font-light">
                <motion.div variants={fadeInUp(0)} initial="initial" animate="animate">
                    <Link
                        to={`/`}
                        className="opacity-50 hover:border-b hover:border-b-black transition-all duration-300 hover:opacity-100 cursor-pointer"
                    >
                        /Anasayfa&nbsp;
                    </Link>
                </motion.div>
                {firstSegment && (
                    <motion.div variants={fadeInUp(0.2)} initial="initial" animate="animate">
                        <Link
                            to={`/${firstSegment}`}
                            className={`${
                                lastIdIndex !== -1 ? 'opacity-50' : 'opacity-100'
                            } hover:border-b hover:opacity-100 hover:border-b-black transition-all duration-300 cursor-pointer`}
                        >
                            /{firstSegmentLabel}&nbsp;
                        </Link>
                    </motion.div>
                )}
                {ids.map((id, index) => {
                    const formattedId = formatId(id);
                    const isActive = lastIdIndex === index;
                    const path = [firstSegment, ...ids.slice(0, index + 1)].filter(Boolean).join('/');
                    return (
                        <motion.div
                            key={index}
                            variants={fadeInUp((index + 1) * 0.2)}
                            initial="initial"
                            animate="animate"
                        >
                            <Link
                                to={`/${path}`}
                                className={`${
                                    isActive ? 'opacity-100' : 'opacity-50'
                                } hover:border-b hover:opacity-100 hover:border-b-black transition-all duration-300 cursor-pointer`}
                            >
                                {formattedId ? `/${formattedId}` : ''}&nbsp;
                            </Link>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
};

export default LinkComponent;
